<template>

<div class="d-flex flex-column justify-content-center align-items-center ">
    <div class="titleAlert">Generar Alerta</div>
    <validation-observer
            ref="vaccineForm"
            #default="{invalid}"
            
          >
          <div class="mt-5 pt-3 ">
            <b-form
              class=" mt-2"
          
            >
              <!-- date -->
              <b-form-group
                label="Fecha"
                label-for="vaccine-date"

              >
                <validation-provider
                  #default="{ errors }"
                  name="VaccineDate"
                  vid="vaccineDate"
                  rules="required|VaccineDate"
                >
                  <b-form-input
                    id="vaccine-date"
                   
                    :state="errors.length > 0 ? false:null"
                    name="vaccine-date"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <div>Filtrar por:</div>
                            <!-- checkbox -->
              <b-form-group>
                <div class="d-flex ">
                <b-form-checkbox
                  id="male"
                  v-model="status"
                  name="checkbox-1"
                >
                  Macho
                </b-form-checkbox>
                <b-form-checkbox
                  id="female"
                  v-model="status"
                  name="checkbox-2"
                  class="ml-3"
                >
                  Hembra
                </b-form-checkbox>
                </div>
              </b-form-group>
               <b-form-group
                    label="Edad"
                    label-for="age"
                    class="mb-2"
                >

                <v-select
                id="age"
                v-model="selected"
                :options="options"
                label="text"
                class="ageSelect "
                /></b-form-group>
        <!-- situation -->
              <b-form-group
                label="Situacion"
                label-for="Exam"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Exam"
                  vid="Exam"
                  rules="required|Exam"
                >
                   <b-form-textarea
                    id="textarea"
                    v-model="text"
                    placeholder="Enter something..."
                    rows="3"
                    max-rows="6"
                    ></b-form-textarea>
                  
                </validation-provider>
              </b-form-group>
              <div>Subir archivo o foto:</div>
            <div class="d-flex justify-content-center">  <b-img src="@/assets/images/ganImage/UpoladImage.png"></b-img></div>
              <!-- submit buttons -->
              <b-button
                type="submit"
                class="bg-primary dataButton mt-1 d-flex align-items-center justify-content-center ml-1"   
            
              >
               <div class="ml-5"> Incluir Evento </div> <div class="pl-5" style="color:#D7B92C"> <feather-icon icon="PlusIcon"  size="18" /></div>
              </b-button>
            </b-form>
            </div>
          </validation-observer>
    <ControlMenu />
</div>
</template>

<script>
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import {BButton, BImg, BFormTextarea,BFormSelect,BForm, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox,} from 'bootstrap-vue'
    import ControlMenu from '@/components/ControlMenu.vue'
    export default {
        components:{
            BButton,
            BFormTextarea,
            BForm,
            BFormSelect,
            BFormGroup,
            ControlMenu,
            BFormInput,
            BInputGroupAppend,
            BInputGroup,
            BFormCheckbox,
            ValidationProvider,
            ValidationObserver,
            vSelect,
            BImg
        },
        data() {
            return {
                status:'',
                selectedAge:[],
                selected:null,
                selected1:null,
                options: [
                {  text: '30' },
                {  text: '21' },
                { text: '33' },
                { text: '10' },
                {  text: '15' },
                 ],
                text:'',

            }
        },

    }
</script>

<style lang="scss">
.titleAlert {
    position: absolute;
    top: 7%;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5E5873;
}

.dataButton {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.4px;
    color: #FFFFFF;
    flex: none;
    order: 1;
}

@import '@core/scss/vue/pages/page-auth.scss';

</style>